import React, { createContext, useState, useContext, useCallback, useEffect } from 'react';
import config from '../config';
import { getUserIdFromUrl } from '../helper/apiHelper';
import { useMaintenanceMode } from './MaintenanceContext';
import { useStatic } from './StaticContext';

// Context oluştur
const BonusContext = createContext();

// LOCAL DEMO: backend olmadan görselsiz tasarımı test edebilmek için
// localhost'ta sahte bonus verisi enjekte edilir. Production'da hiç çalışmaz.
const IS_LOCAL_DEMO = typeof window !== 'undefined' &&
  (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');

const MOCK_BONUS_DATA = {
  full_name: 'Demo Kullanıcı',
  talep_data: [
    {
      bonus_type: 'Tümü, Spor',
      bonus_gorsel: '/static/image/long.webp',
      data: [{
        bonus_name: '%20 Kolay Çevrimli Spor Yatırım Bonusu',
        process_name: 'demo-spor-yatirim',
        kurallar: [{ title: 'Şartlar', metin: 'Min. 100 TL yatırım şartı.' }],
        is_bakim: false,
        talep_text: null,
        redirect_link: null,
      }],
    },
    {
      bonus_type: 'Tümü',
      bonus_gorsel: '/static/image/long.webp',
      data: [{
        bonus_name: 'İlk Yatırıma Özel %100 İade Bonusu',
        process_name: 'demo-ilk-yatirim',
        kurallar: [],
        is_bakim: false,
        talep_text: null,
        redirect_link: null,
      }],
    },
    {
      bonus_type: 'Tümü, Yatırım',
      bonus_gorsel: '/static/image/long.webp',
      data: [{
        bonus_name: '1000TL Yatırıma 1000TL Bonus',
        process_name: 'demo-1000-1000',
        kurallar: [],
        is_bakim: false,
        talep_text: null,
        redirect_link: null,
      }],
    },
    {
      bonus_type: 'Tümü, Deneme',
      bonus_gorsel: '/static/image/long.webp',
      data: [{
        bonus_name: 'Telegram Deneme Bonusu',
        process_name: 'demo-telegram-deneme',
        kurallar: [{ title: 'Şartlar', metin: 'Telegram kanalına katılım gerekir.' }],
        is_bakim: false,
        talep_text: null,
        redirect_link: null,
      }],
    },
    {
      bonus_type: 'Tümü, Hoşgeldin, Casino',
      bonus_gorsel: '/static/image/long.webp',
      data: [{
        bonus_name: '10.000₺ Casino Hoşgeldin Bonusu',
        process_name: 'demo-casino-hosgeldin',
        kurallar: [],
        is_bakim: false,
        talep_text: null,
        redirect_link: null,
      }],
    },
    {
      bonus_type: 'Tümü, Casino',
      bonus_gorsel: '/static/image/long.webp',
      data: [{
        bonus_name: '%25 Gecelik Slot Çevrim Bonusu',
        process_name: 'demo-gece-slot',
        kurallar: [],
        is_bakim: false,
        talep_text: null,
        redirect_link: null,
      }],
    },
    {
      bonus_type: 'Tümü, Kayıp',
      bonus_gorsel: '/static/image/long.webp',
      data: [{
        bonus_name: 'Haftalık Casino Kayıp Bonusu',
        process_name: 'demo-haftalik-kayip',
        kurallar: [{ title: 'Şartlar', metin: 'Haftalık net kayıp üzerinden.' }],
        is_bakim: false,
        talep_text: null,
        redirect_link: null,
      }],
    },
    {
      bonus_type: 'Tümü, Çark',
      bonus_gorsel: '/static/image/long.webp',
      data: [{
        bonus_name: 'Günlük Şans Çarkı',
        process_name: 'demo-cark',
        kurallar: [],
        is_bakim: false,
        talep_text: null,
        redirect_link: null,
      }],
    },
  ],
  bonus_type_tabs: ['Tümü', 'Spor', 'Casino', 'Hoşgeldin', 'Çark', 'Kayıp', 'Yatırım', 'Deneme'],
};

const demoWidgetImg = (seed = 0) =>
  'data:image/svg+xml;utf8,' + encodeURIComponent(
    `<svg xmlns="http://www.w3.org/2000/svg" width="450" height="200">` +
    `<defs><radialGradient id="gw${seed}" cx="50%" cy="50%" r="70%">` +
    `<stop offset="0" stop-color="#4a3c16"/><stop offset="55%" stop-color="#241d0d"/><stop offset="100%" stop-color="#0d1117"/>` +
    `</radialGradient></defs>` +
    `<rect width="450" height="200" fill="url(#gw${seed})"/>` +
    `<circle cx="225" cy="100" r="48" fill="none" stroke="#c9a84c" stroke-width="2" opacity="0.45"/>` +
    `<circle cx="225" cy="100" r="32" fill="#e3c272" opacity="0.15"/>` +
    `<text x="225" y="108" fill="#e3c272" font-size="28" font-weight="bold" text-anchor="middle" font-family="Arial">★</text>` +
    `</svg>`
  );

const MOCK_WIDGET_BONUS_DATA = [
  {
    talep_id: 'demo-widget-2',
    bonus_gorsel: demoWidgetImg(2),
    bonus_type: 'Tümü, Casino',
    data: [{
      bonus_name: 'GÜNLÜK BONUS',
      process_name: 'demo-gunluk',
      is_bakim: false,
      widget_time: 0,
      widget_bonus: true,
      cron_query: "0 0 * * *",
      cron_end: null,
      redirect_link: null,
      talep_text: null,
      kurallar: [],
      again_request_time: 0,
    }],
  },
  {
    talep_id: 'demo-widget-3',
    bonus_gorsel: demoWidgetImg(3),
    bonus_type: 'Tümü, Kayıp',
    data: [{
      bonus_name: 'HAFTALIK BONUS',
      process_name: 'demo-haftalik',
      is_bakim: false,
      widget_time: 0,
      widget_bonus: true,
      cron_query: "0 0 * * 2",
      cron_end: null,
      redirect_link: null,
      talep_text: null,
      kurallar: [],
      again_request_time: 25000,
    }],
  },
  {
    talep_id: 'demo-widget-4',
    bonus_gorsel: demoWidgetImg(4),
    bonus_type: 'Tümü, Sadakat',
    data: [{
      bonus_name: 'AYLIK BONUS',
      process_name: 'demo-aylik',
      is_bakim: false,
      widget_time: 0,
      widget_bonus: true,
      cron_query: "0 0 1 * *",
      cron_end: null,
      redirect_link: null,
      talep_text: null,
      kurallar: [],
      again_request_time: 150000,
    }],
  },
];

// Bonus verisini sağlayacak context provider
export const BonusProvider = ({ children }) => {
  const [bonusData, setBonusData] = useState([]);
  const [tabs, setTabs] = useState([]);
  const [widgetBonusData, setWidgetBonusData] = useState([]);
  const [widgetLoading, setWidgetLoading] = useState(true);
  const [widgetError, setWidgetError] = useState(null);
  const [gamesData, setGamesData] = useState([]);
  const [gamesTabs, setGamesTabs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [gamesLoading, setGamesLoading] = useState(true);
  const [error, setError] = useState(null);
  const [gamesError, setGamesError] = useState(null);
  const userId = getUserIdFromUrl();
  const [userName, setUserName] = useState('');
  const { isMaintenanceMode } = useMaintenanceMode(); // Bakım modu bilgisini al
  const { isLanguage, selectedLanguage } = useStatic(); // Dil ayarlarını al

  const fetchBonusForUser = useCallback(async () => {
    // LOCAL DEMO: backend yok → mock data ile görselsiz tasarımı göster
    if (IS_LOCAL_DEMO) {
      setUserName(MOCK_BONUS_DATA.full_name);
      setBonusData(MOCK_BONUS_DATA.talep_data);
      setTabs(MOCK_BONUS_DATA.bonus_type_tabs);
      setWidgetBonusData(MOCK_WIDGET_BONUS_DATA);
      setWidgetLoading(false);
      setError(null);
      setLoading(false);
      return;
    }

    // Önce userId kontrolü yap
    if (!userId) {
      setError("invalid_access");
      setWidgetError("invalid_access");
      setLoading(false);
      setWidgetLoading(false);
      return;
    }

    try {
      // İstek payload'larını oluştur
      const payload = {
        process_id: "getc-bonuses",
        user_id: userId,
        recaptcha: "test",
      };

      const payloadWidget = {
        process_id: "getc-widget-bonuses",
        user_id: userId,
        recaptcha: "test",
      };

      // Bakım modu kontrolü
      if (isMaintenanceMode) {
        payload.dev = "10";
        payloadWidget.dev = "10";
      }

      // Dil desteği kontrolü
      if (isLanguage && selectedLanguage) {
        payload.lang = selectedLanguage;
        payloadWidget.lang = selectedLanguage;
      }

      let body = JSON.stringify(payload);
      let keys = await window.rh.cr(body);

      let bodyWidget = JSON.stringify(payloadWidget);
      let keysWidget = await window.rh.cr(bodyWidget);
      
      const [response, responseWidget] = await Promise.all([
        fetch(`${config.apiBaseUrl}`, {
          method: "POST",
          headers: { 
            "Content-Type": "application/json", 
            "hk": keys[0],
            "hh": keys[1]
          },
          body: body,
        }),
        fetch(`${config.apiBaseUrl}`, {
          method: "POST",
          headers: { 
            "Content-Type": "application/json", 
            "hk": keysWidget[0],
            "hh": keysWidget[1]
          },
          body: bodyWidget,
        }).catch(err => {
          console.warn("Widget bonus fetch error:", err);
          return null;
        })
      ]);

      // 403 hatası kontrolü
      if (response.status === 403) {
        setError("user_blocked");
        setLoading(false);
        return;
      }

      const result = await response.json();

      if (result.status) {
        setUserName(result.full_name);
        setBonusData(result.data.talep_data);
        setTabs(result.data.bonus_type_tabs);
        setError(null);
        setLoading(false);
      } else if (result.message === "Bilinmeyen kullanıcı") {
        setError("user_not_found");
        setLoading(false);
      } else {
        setError("api_error");
        setLoading(false);
      }

      // Widget bonus verilerini işle
      if (responseWidget && responseWidget.ok) {
        const resultWidget = await responseWidget.json();
        if (resultWidget.status) {
          const talep = resultWidget.data?.talep_data || [];
          setWidgetBonusData(talep);
          setWidgetError(null);
        } else {
          setWidgetError(resultWidget.message || "api_error");
        }
      } else {
        setWidgetError("api_error");
      }
      setWidgetLoading(false);
    } catch (error) {
      console.error("İstek sırasında hata oluştu:", error);
      setError("connection_error");
      setWidgetError("connection_error");
      setLoading(false);
      setWidgetLoading(false);
    }
  }, [userId, isMaintenanceMode, isLanguage, selectedLanguage]);

  const fetchGamesForUser = useCallback(async () => {
    // LOCAL DEMO: backend yok → mock games (boş set) ile graceful başlat
    if (IS_LOCAL_DEMO) {
      setGamesData([]);
      setGamesTabs([]);
      setGamesError(null);
      setGamesLoading(false);
      return;
    }

    // Önce userId kontrolü yap
    if (!userId) {
      setGamesError("invalid_access");
      setGamesLoading(false);
      return;
    }

    try {
      // İstek payload'ını oluştur
      const payload = {
        process_id: "getc-games",
        user_id: userId,
        recaptcha: "test",
      };

      // Bakım modu kontrolü
      if (isMaintenanceMode) {
        payload.dev = "10";
      }

      // Dil desteği kontrolü
      if (isLanguage && selectedLanguage) {
        payload.lang = selectedLanguage;
      }

      let body = JSON.stringify(payload);
      let keys = await window.rh.cr(body);
      
      const response = await fetch(`${config.apiBaseUrl}`, {
        method: "POST",
        headers: { 
          "Content-Type": "application/json", 
          "hk": keys[0],
          "hh": keys[1]
        },
        body: body,
      });

      // 403 hatası kontrolü
      if (response.status === 403) {
        setGamesError("user_blocked");
        setGamesLoading(false);
        return;
      }

      const result = await response.json();

      if (result.status) {
        setGamesData(result.data.talep_data);
        setGamesTabs(result.data.bonus_type_tabs || []);
        setGamesError(null);
        setGamesLoading(false);
      } else if (result.message === "Bilinmeyen kullanıcı") {
        setGamesError("user_not_found");
        setGamesLoading(false);
      } else {
        setGamesError("api_error");
        setGamesLoading(false);
      }
    } catch (error) {
      console.error("Oyunlar API isteği sırasında hata oluştu:", error);
      setGamesError("connection_error");
      setGamesLoading(false);
    }
  }, [userId, isMaintenanceMode, isLanguage, selectedLanguage]);

  // Bonus verisi, loading durumu ve hata bilgisini sağlayan context
  return (
    <BonusContext.Provider value={{ 
      bonusData, 
      loading, 
      error, 
      tabs, 
      fetchBonusForUser, 
      widgetBonusData,
      widgetLoading,
      widgetError,
      gamesData,
      gamesLoading,
      gamesError,
      gamesTabs,
      fetchGamesForUser,
      userName, 
      userId 
    }}>
      {children}
    </BonusContext.Provider>
  );
};

// Context'teki veriye erişmek için kullanılacak özel hook
export const useBonus = () => useContext(BonusContext);